import { newrelic } from "@jti/fe-clients";
import { BaseGTMRunner } from "../BaseGTM/BaseGTMRunner";
let instance = null;
export class GTMEVARunner extends BaseGTMRunner {
    constructor() {
        super();
        this.trackCustomEvents();
        this.trackMessageBusEvents();
    }
    initialize(gtmContainer, pageType) {
        this.gtmContainer = gtmContainer;
        this.isCartPage = pageType === "cart";
        this.isLoyaltyPage = pageType === "loyalty";
        this.onLoadTracking = undefined;
        if (this.gtmContainer) {
            this.onLoadTracking = this.gtmContainer.dataset.onLoadTracking;
            const code = this.gtmContainer.dataset.gtmCode;
            this.currentName = this.getCurrentNameForGtm();
            if (code && this.currentName) {
                this.instance = null;
                this.handleHashChange();
            }
        }
    }
    waitForInstance() {
        return new Promise((resolve, reject) => {
            if (this.instance) {
                resolve(this.instance);
            }
            else {
                newrelic.noticeError(new Error("The instance for GTMEVARunner is not available"));
                reject(new Error("The instance for GTMEVARunner is not available"));
            }
        });
    }
    static getInstance(gtmContainer = null, pageType = "other") {
        if (!instance) {
            instance = new GTMEVARunner();
        }
        instance.initialize(gtmContainer, pageType);
        return instance;
    }
}
//# sourceMappingURL=GTMEVARunner.js.map